import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Spacer,
  Tr,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import { FiArrowLeft, FiPlus, FiXCircle } from "react-icons/fi";
import InputMask from "react-input-mask";

import { useForm } from "react-hook-form";

import moment from "moment";
import { NumericFormat, PatternFormat } from "react-number-format";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";

import { useEffect, useState } from "react";
import ExtratoApi from "../../../../services/ExtratoAPI";
import PaymentApiNovo from "../../../../services/paymentApiNovo";
import ClientApi from "../../../../services/clientApi";
import {
  dateForList,
  dateForValueInput,
} from "../../../../constants/dataFormat";
import { goToPaymentSolicitationListNew } from "../../../../routes/coordinator";
import { JWTToken } from "../../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { customColors } from "../../../../atoms/customColors";
import ModalConfirmTransf from "./modalConfirmTransf";
import { LoggedUser } from "../../../../atoms/userLogged";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";

const utils = require("@mrmgomes/boleto-utils");

function AddPaymentNew() {
  const navigate = useNavigate();

  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const [cliente, setCliente] = useState(0);
  const todayMorning = moment()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const todayNight = moment()
    .endOf("day")
    // .add("day", 2)
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const [saldoCliente, setSaldoCliente] = useState(0);
  const [nomeCliente, setNomeCliente] = useState("");
  const [loading, setLoading] = useState(false);

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const id = Number(jwtToken.idCliente);

  const colors = useRecoilState(customColors)[0];

  interface IFormInputs {
    idCliente: any;
    codigoBarras: string;
    valorPagamento: number;
    dataPagamento: string;
  }
  interface User {
    id: number;
    nome: string;
    email: string;
    ativo: boolean;
    idEmpresa?: number | null;
    idCliente?: number | null;
    idVendedor?: number | null;
    idProjeto?: number | null;
    idLoginTipo: number;
    apiout: boolean;
    primeiroAcesso: boolean;
    expiracaoSenha: string;
    idTipoGestor?: number | null;
    loginControle: {
      idLogin: number;
      primeiroAcesso: boolean;
      expiracaoSenha: string;
      celular?: string | null;
      tipo2FA?: string | null;
      isAtivo?: boolean | null;
      idTipoUsuario?: number | null;
    };
  }

  const initialValues = {
    idCliente: id,
    codigoBarras: "",
    valorPagamento: 0,
    dataPagamento: moment().format("DD/MM/YYYY"),
  };

  const [pagamento, setPagamento] = useState<IFormInputs>(initialValues);
  const [listaPagamento, setListaPagamento] = useState<IFormInputs[]>([]);
  useEffect(() => {
    setPagamento((prevState) => ({
      ...prevState,
      dataPagamento: moment().format("DD/MM/YYYY"),
    }));
  }, []);
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm<IFormInputs>();

  async function getSaldo() {
    try {
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        todayMorning,
        todayNight,
        id
      );
      setSaldoCliente(
        response.data[0] &&
          response.data[0].saldoAnterior + response.data[0].saldoPeriodo
      );
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getSaldo();
  }, []);

  const [code, setCode] = useState("");
  const [openCodeModal, setOpenCodeModal] = useState(false);

  function onSubmit() {
    // console.log(pagamento);
    if (pagamento.codigoBarras !== "" && pagamento.dataPagamento !== "") {
      if (pagamento.valorPagamento > saldoCliente) {
        // Validar saldo
        toast.error("O saldo é insuficiente para a operação!");
      } else {
        const objeto = {
          idCliente: id,
          codigoBarras: pagamento.codigoBarras,
          dataPagamento: moment(pagamento.dataPagamento).format("YYYY-MM-DD"),
          valorPagamento: pagamento.valorPagamento,
        };
        setListaPagamento([...listaPagamento, objeto]);
        setPagamento(objeto);
        setCliente(0);
        setOpenCodeModal(true);
      }
    } else {
      toast.error("Preencha os campos para registrar a solicitação!");
    }
  }

  async function postPagamentos(codeResponse: string) {
    if (pagamento.idCliente === 0) {
      toast.error("Selecione um cliente para fazer a solicitação");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await PaymentApiNovo.postPaymentSolicitation(
        pagamento,
        codeResponse
      );
      toast.success("Solicitação de pagamento registrada com sucesso!");
      toast.success("Seu boleto será processado em breve!");
      setRefreshGlobal(refresh + 1);
      setListaPagamento([]);
      goToPaymentSolicitationListNew(navigate);
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível cadastrar a solicitação");
      setLoading(false);
      console.log("error: " + error);
    }
  }

  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  async function getClientPerId() {
    try {
      const response = await ClientApi.getClientPerId(id);
      setNomeCliente(
        response.isCnpj === true
          ? response.razaoSocial
          : `${response.nome} ${response.sobrenome}`
      );
    } catch (error) {
      // console.log("error", error);
    }
  }
  useEffect(() => {
    getClientPerId();
  }, []);

  function getInformationByBarCode(item: any) {
    const _item = item.replace(/[^0-9]/g, "");
    if (_item.length <= 48) setPagamento({ ...pagamento, codigoBarras: _item });

    if (_item.length < 44 || _item.length > 48) {
      setError("codigoBarras", {
        type: "onBlur",
        message:
          "O código de barras ou linha digitável deve ter entre 44 e 48 caracteres.",
      });
      return;
    } else {
      setError("codigoBarras", {
        type: "onBlur",
        message: "",
      });
    }

    if (_item === "") {
      setError("codigoBarras", {
        type: "onBlur",
        message: "Digite o código do boleto.",
      });
    }
  }

  const MASK_ARRECADACAO44 =
    "#####.##### #####.###### #####.###### # ##############";
  const MASK_COBRANCA47 = "#####.##### #####.###### #####.###### # ###########";
  const MASK_COBRANCA48 =
    "#####.##### #####.###### #####.###### #####.###### ##";
  const NO_MASK = "################################################";

  const transferData = {
    ...pagamento,
    idCliente: id,
  };

  return (
    <Flex flexDir={"column"} height="fit-content" width="100%">
      <Box
        width="100%"
        bgColor={colors.WHITE}
        height="fit-content"
        shadow="md"
        mt="0.3%"
        mx="auto"
        py={2}
        px={3}
      >
        <Flex alignItems="center" px={5}>
          <Text fontWeight="bold" fontSize="18px">
            Nova Solicitação de Pagamento de Boletos Novo
          </Text>
          <Spacer />
          <Button
            leftIcon={<FiArrowLeft />}
            bgColor={colors.GRAY_NEUTRAL}
            color="white"
            onClick={() => {
              goToPaymentSolicitationListNew(navigate);
            }}
          >
            Voltar
          </Button>
        </Flex>
      </Box>

      <Flex w={"100%"} h={"84vh"} overflowY={"scroll"} flexDirection={"column"}>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          justifyItems={"center"}
          mt={"0.3%"}
          mx="auto"
          py={2}
          px={3}
        >
          <Flex
            justify="flex-start"
            ml={4}
            flexDirection={"column"}
            color={colors.BLUEMONEDD}
          >
            <Text fontSize={"12px"} my={1}>
              Informe os dados a seguir e clique em adicionar.
            </Text>
            <Text fontSize={"12px"} my={1}>
              Atenção : No campo valor, informe o valor correto a ser pago do
              boleto.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Solicitações de pagamentos bancários só são possíveis de 08h até
              ás 17h, de segunda a sexta, exceto feriados.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Não é possível realizar solicitações de pagamentos bancários
              após as 17h, finais de semana e feriados.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Cliente Monedd tem direito a pagamentos de boletos sem custo e
              sem limite de quantidade.
            </Text>
          </Flex>
        </Box>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          mt={"0.3%"}
          mx="auto"
          py={3}
          px={10}
        >
          <Flex width={"100%"} height={"60%"} flexDirection="column" mb={"3%"}>
            <form>
              <Flex my={2} flexDirection={"column"}>
                <Text fontWeight="bold" my={1}>
                  Saldo:{" "}
                  {saldoCliente
                    ? saldoCliente.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    : "R$ 0,00"}{" "}
                </Text>
              </Flex>
              <Flex>
                <FormControl>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Código de Barras ou Linha Digitável
                  </FormLabel>
                  <PatternFormat
                    customInput={Input}
                    format={NO_MASK}
                    placeholder={"Código de Barras ou Linha digitável"}
                    value={pagamento.codigoBarras}
                    {...register("codigoBarras", { required: true })}
                    onChange={(e: any) => {
                      const unmaskedValue = unMask(e.target.value);
                      if (unmaskedValue.length <= 48) {
                        setPagamento((prev) => ({
                          ...prev,
                          codigoBarras: unmaskedValue,
                        }));
                        getInformationByBarCode(unmaskedValue);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  />
                  <Text color={colors.REDMONEDD}>
                    {errors.codigoBarras?.message}{" "}
                  </Text>
                </FormControl>
                {/*     <FormControl my={2} mx={2} isInvalid={!!errors.dataPagamento}>
      <FormLabel fontWeight={"bold"} fontSize={"16px"}  width={"50%"}>
        Data para Pagamento
      </FormLabel>
      <Input
       
        type="text"
        placeholder="Selecione a data"
        value={pagamento.dataPagamento}
        readOnly
        {...register("dataPagamento", { value: pagamento.dataPagamento })}
      />
      <FormErrorMessage>
        {errors.dataPagamento && errors.dataPagamento.message}
      </FormErrorMessage>
    </FormControl> */}
              </Flex>
              <Flex flexDir={"row"}>
                {/*  <FormControl my={2} mx={2}>
                <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                  Valor a Pagar
                </FormLabel> 
                <NumericFormat
                  decimalScale={2}
                  prefix="R$ "
                  value={pagamento.valorPagamento}
                  decimalSeparator=","
                  customInput={Input}
                  type="text"
                  placeholder="R$ 0,00"
                  onChange={(e: any) => {
                    OnChangeValueInput(e.target.value);
                  }}
                />
              </FormControl> */}
              </Flex>
              <Button
                onClick={() => onSubmit()}
                mt={5}
                leftIcon={<FiPlus />}
                bgColor={colors.BLUEMONEDDBUTTONS}
                style={{ color: "white" }}
                _hover={{ bg: "#4B4B57" }}
                isDisabled={
                  pagamento.codigoBarras &&
                  pagamento.codigoBarras.length >= 44 &&
                  pagamento.codigoBarras.length <= 48 &&
                  id > 0
                    ? false
                    : true
                }
              >
                Cadastrar
              </Button>
            </form>
          </Flex>
        </Box>
      </Flex>
      <ModalConfirmTransf
        isOpen={openCodeModal}
        setIsOpen={setOpenCodeModal}
        functionPai={postPagamentos}
        setCode={setCode}
        type={"pagamento"}
        email={user.email}
        transferData={transferData}
      />
    </Flex>
  );
}

export default AddPaymentNew;
